import { normalizeObject, dataLayerPush } from "../shared/utils";
var cartRemoveHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
    };
    var cartItem = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    // TODO: Need to send this barnd from Cart.
    var brand = cartItem["product_sku"] === "S1000002" ? "chosen_sponsorship" : (cartItem["product_id"] === "380" ? "sponsorship" : "gift_catalog");
    Object.assign(dataLayerEventData, {
        event: "remove_from_cart",
        event_action: "remove_from_cart",
        event_category: "ecommerce",
        event_label: cartItem["product_name"],
        ecommerce: {
            items: [{
                    item_brand: brand,
                    item_id: cartItem["product_sku"],
                    item_category: cartItem["category"],
                    item_variant: cartItem["variant"] + ":" + cartItem["product_price"],
                    item_name: cartItem["product_name"],
                    price: cartItem["product_price"],
                    quantity: cartItem["product_quantity"]
                }]
        }
    });
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
var expressPaymentViewHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
    };
    Object.assign(dataLayerEventData, {
        event: "express_payment_method_view",
        event_action: "express_payment_method_view",
        event_category: "payment_method",
        event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"],
        non_interaction: true,
    });
    dataLayerPush(dataLayerEventData);
};
var expressPaymentClickHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
    };
    var eventDetails = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    var cartProducts = [];
    var cartTotal = 0;
    eventDetails["wvus_cart_products"] && Object.values(eventDetails["wvus_cart_products"]).forEach(function (cartItem) {
        var brand = cartItem["is_chosen"] ? "chosen_sponsorship" : (cartItem["is_sponsorship"] ? "sponsorship" : "gift_catalog");
        cartTotal += parseInt(cartItem["price"] || 0);
        cartProducts.push({
            item_brand: brand,
            item_category: cartItem["category"],
            item_id: cartItem["sku"],
            item_name: cartItem["name"],
            item_variant: cartItem["variant"] + ":" + parseInt(cartItem["price"]),
            price: parseInt(cartItem["price"]),
            quantity: cartItem["quantity"]
        });
    });
    Object.assign(dataLayerEventData, {
        event: "begin_checkout",
        event_action: "express_payment_method_click",
        event_category: "ecommerce",
        event_label: eventDetails["event_label"],
        step_number: 1,
        hi_checkout_start: 1,
        high_intent_interactions: 1,
        checkout_type: "ecomm_express_payment",
        ecommerce: {
            currency: "USD",
            value: cartTotal,
            items: cartProducts
        }
    });
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
var beginCheckoutHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
    };
    var eventDetails = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    var cartProducts = [];
    var checkoutType = "ecomm";
    var cartTotal = 0;
    eventDetails["wvus_cart_products"] && Object.values(eventDetails["wvus_cart_products"]).forEach(function (cartItem) {
        var brand = cartItem["is_chosen"] ? "chosen_sponsorship" : (cartItem["is_sponsorship"] ? "sponsorship" : "gift_catalog");
        if (cartItem["honor_card"] === "on") {
            checkoutType = "ecomm_shipping";
        }
        cartTotal += parseInt(cartItem["price"] || 0);
        cartProducts.push({
            item_brand: brand,
            item_category: cartItem["category"],
            item_id: cartItem["sku"],
            item_name: cartItem["name"],
            item_variant: cartItem["variant"] + ":" + parseInt(cartItem["price"]),
            price: parseInt(cartItem["price"]),
            quantity: cartItem["quantity"]
        });
    });
    Object.assign(dataLayerEventData, {
        event: "begin_checkout",
        event_action: "checkout_start",
        event_category: "ecommerce",
        event_label: document.title,
        step_number: 1,
        hi_checkout_start: 1,
        high_intent_interactions: 1,
        checkout_type: checkoutType,
        ecommerce: {
            currency: "USD",
            value: cartTotal,
            items: cartProducts
        }
    });
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
var woocommErrorHandler = function (e) {
    var _a;
    var woocommErrorNotices = ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.errorMessages) || [];
    // add each error message to the dataLayer
    woocommErrorNotices.forEach(function (errorNotice) {
        var error_message = errorNotice.error_message, error_type = errorNotice.error_type, category = errorNotice.category;
        var dataLayerEventData = {
            error_message: error_message,
            error_type: error_type,
            event: "error_view",
            event_action: "error_view",
            event_category: category || "error",
            event_errors: 1,
            event_label: error_message,
            non_interaction: true,
            total_errors: (woocommErrorNotices === null || woocommErrorNotices === void 0 ? void 0 : woocommErrorNotices.length) || 1
        };
        dataLayerPush(normalizeObject(dataLayerEventData));
    });
};
export { cartRemoveHandler, expressPaymentViewHandler, expressPaymentClickHandler, beginCheckoutHandler, woocommErrorHandler };
